import { ValuesOf } from '@tmapy/beetlejuice-utils';

import { AttachmentTypeEnum } from '../openapi/types/AttachmentTypeEnum';
import { DataOriginEnum } from '../openapi/types/DataOriginEnum';
import { DocumentationTypeEnum } from '../openapi/types/DocumentationTypeEnum';
import { RejectionReasonEnum } from '../openapi/types/RejectionReasonEnum';
import { DocStatesEnum as DOC_STATE } from '../openapi/types/DocStatesEnum';
import { FlowEnum } from '../openapi/types/FlowEnum';
import { Roles } from '../openapi/types/Roles';
import { DmxConfig } from '../types';

export { DocStatesEnum as DOC_STATE } from '../openapi/types/DocStatesEnum';
export { DocCheckStateEnum as CHECK_STATE } from '../openapi/types/DocCheckStateEnum';

// DOC EDIT
export const DOCEDIT_LOAD_SUCCESS = 'DOCEDIT_LOAD_SUCCESS';
export const DOCEDIT_LOAD_FAILURE = 'DOCEDIT_LOAD_FAILURE';
export const DOCEDIT_LOAD_WAITING = 'DOCEDIT_LOAD_WAITING';
export const DOCEDIT_CLEAR = 'DOCEDIT_CLEAR';
export const DOCEDIT_SUBMIT_FAILURE = 'DOCEDIT_SUBMIT_FAILURE';
export const DOCEDIT_SUBMIT_SUCCESS = 'DOCEDIT_SUBMIT_SUCCESS';
export const DOCEDIT_SUBMIT_WAITING = 'DOCEDIT_SUBMIT_WAITING';
// DOC DETAIL
export const DOCDETAIL_REMOVE_WAITING = 'DOCDETAIL_REMOVE_WAITING';
export const DOCDETAIL_REMOVE_SUCCESS = 'DOCDETAIL_REMOVE_SUCCESS';
export const DOCDETAIL_REMOVE_FAILURE = 'DOCDETAIL_REMOVE_FAILURE';
export const DOCDETAIL_CHANGE_STATE = 'DOCDETAIL_CHANGE_STATE';
export const DOCDETAIL_FILES_UPLOAD_WAITING = 'DOCDETAIL_FILES_UPLOAD_WAITING';
export const DOCDETAIL_FILES_UPLOAD_SUCCESS = 'DOCDETAIL_FILES_UPLOAD_SUCCESS';
export const DOCDETAIL_FILES_UPLOAD_FAILURE = 'DOCDETAIL_FILES_UPLOAD_FAILURE';
export const DOCDETAIL_FILES_UPLOAD_CANCEL = 'DOCDETAIL_FILES_UPLOAD_CANCEL';
export const DOCDETAIL_FILES_SET_UPLOAD_PROGRESS = 'DOCDETAIL_FILES_SET_UPLOAD_PROGRESS';
export const DOCDETAIL_FILES_DELETE_START = 'DOCDETAIL_FILES_DELETE_START';
export const DOCDETAIL_FILES_DELETE_SUCCESS = 'DOCDETAIL_FILES_DELETE_SUCCESS';
export const DOCDETAIL_FILES_SET_TYPE_SUCCESS = 'DOCDETAIL_FILES_SET_TYPE_SUCCESS';
export const DOCDETAIL_LOAD_WAITING = 'DOCDETAIL_LOAD_WAITING';
export const DOCDETAIL_LOAD_SUCCESS = 'DOCDETAIL_LOAD_SUCCESS';
export const DOCDETAIL_LOAD_FAILURE = 'DOCDETAIL_LOAD_FAILURE';
export const DOCDETAIL_SIGNED_PROTOCOL_UPLOAD_SUCCESS = 'DOCDETAIL_SIGNED_PROTOCOL_UPLOAD_SUCCESS';
export const DOCDETAIL_SIGNED_PROTOCOL_UPLOAD_FAILURE = 'DOCDETAIL_SIGNED_PROTOCOL_UPLOAD_FAILURE';
export const DOCDETAIL_SIGNED_PROTOCOL_UPLOAD_WAITING = 'DOCDETAIL_SIGNED_PROTOCOL_UPLOAD_WAITING';
export const DOCDETAIL_UPDATE = 'DOCDETAIL_UPDATE';

export type DocFormTypes =
  | 'check'
  | 'doc'
  | 'initialImport'
  | 'podaniDTI'
  | 'dmvsDti'
  | 'dmvsGad'
  | 'cepro'
  | 'bb'
  | 'podaniKAD';

export const DOC_STATES_PREJIMKA: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  INPROGRESS: ['INPROGRESS'],
  SUBMITTED: ['SUBMITTED'],
  ACCEPTED: [
    'ACCEPTED',
    'WAITING_FOR_IMPORT',
    'IMPORTING',
    'IMPORT_FAILED',
    'IMPORT_FAILED',
    'PREPARING_FOR_EDIT',
    'PREPARING_FOR_EDIT_WITH_ERRORS',
    'EDITING',
    'EDIT_SUPERVISING',
    'EDIT_REJECTED',
  ],
  SIGNING: ['SIGNING'],
  REJECTED: ['REJECTED'],
  CANCELED: ['CANCELED'],
  DRAFT_CHECKED: ['DRAFT_CHECKED'],
};

export const DOC_STATES_MANAGER: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  INPROGRESS: ['INPROGRESS'],
  ACCEPTED: ['ACCEPTED'],
  WAITING_FOR_IMPORT: ['WAITING_FOR_IMPORT'],
  IMPORTING: ['IMPORTING'],
  IMPORT_FAILED: ['IMPORT_FAILED'],
  PREPARING_FOR_EDIT_WITH_ERRORS: ['PREPARING_FOR_EDIT_WITH_ERRORS', 'IMPORTED_WITH_ERRORS'],
  PREPARING_FOR_EDIT: ['PREPARING_FOR_EDIT', 'IMPORTED'],
  IMPORT_INTERRUPTED: ['IMPORT_INTERRUPTED'],
  EDITING: ['EDITING'],
  SUBMITTED: ['SUBMITTED'],
  REJECTED: ['REJECTED'],
  CANCELED: ['CANCELED'], // ? - DMVS_DTI_REJECTED
  WAITING_FOR_CLOSE: ['WAITING_FOR_CLOSE', 'WAITING_FOR_CLOSE_FINAL'],
  CLOSING: ['CLOSING', 'CLOSING_FINAL', 'NOTIFYING_CLOSE'],
  NOTIFYING_CLOSE: ['NOTIFYING_CLOSE'],
  CLOSE_FAILED: ['CLOSE_FAILED'],
  CLOSED: ['CLOSED', 'CLOSED_FINAL'],
  CLOSE_CHECKS_FAILED: ['CLOSE_CHECKS_FAILED'],
  CLOSE_INTERRUPTED: ['CLOSE_INTERRUPTED'],
  NOTIFYING_CLOSE_FAILED: ['NOTIFYING_CLOSE_FAILED'],
  WAITING_FOR_REJECT: ['WAITING_FOR_REJECT'],
  WAITING_FOR_REJECT_FAILED: ['WAITING_FOR_REJECT_FAILED'],
  CLOSING_READY_TO_SEND_TO_DMVS: ['CLOSING_READY_TO_SEND_TO_DMVS'],
  SENT_TO_DMVS: ['SENT_TO_DMVS'],
};
export const DOC_STATES_FILTER_DMVS_DTI: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  WAITING_FOR_IMPORT: ['WAITING_FOR_IMPORT'],
  IMPORTING: ['IMPORTING'],
  IMPORT_INTERRUPTED: ['IMPORT_INTERRUPTED'],
  WAITING_FOR_CLOSE: ['WAITING_FOR_CLOSE'],
  CLOSING: ['CLOSING', 'NOTIFYING_CLOSE'],
  CLOSE_INTERRUPTED: ['CLOSE_INTERRUPTED'],
  IMPORT_FAILED: ['IMPORT_FAILED'],
  CLOSE_FAILED: ['CLOSE_FAILED'],
  CLOSE_CHECKS_FAILED: ['CLOSE_CHECKS_FAILED'],
  NOTIFYING_CLOSE_FAILED: ['NOTIFYING_CLOSE_FAILED'],
  CLOSED: ['CLOSED'],
  REJECTED: ['REJECTED'],
};
export const DOC_STATES_FILTER_DMVS_GAD: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  SUBMITTED: ['SUBMITTED'],
  REJECTED: ['REJECTED'],
  WAITING_FOR_IMPORT: ['WAITING_FOR_IMPORT'],
  WAITING_FOR_REJECT: ['WAITING_FOR_REJECT'],
  WAITING_FOR_REJECT_FAILED: ['WAITING_FOR_REJECT_FAILED'],
  IMPORT_INTERRUPTED: ['IMPORT_INTERRUPTED'],
  CLOSE_INTERRUPTED: ['CLOSE_INTERRUPTED'],
  IMPORTING: ['IMPORTING'],
  IMPORT_FAILED: ['IMPORT_FAILED'],
  IMPORTED: ['IMPORTED'],
  IMPORTED_WITH_ERRORS: ['IMPORTED_WITH_ERRORS'],
  SIGNED_FAILED: ['SIGNED_FAILED'],
  WAITING_FOR_CLOSE: ['WAITING_FOR_CLOSE'],
  CLOSING: ['CLOSING', 'NOTIFYING_CLOSE'],
  NOTIFYING_CLOSE_FAILED: ['NOTIFYING_CLOSE_FAILED'],
  EDITING: ['EDITING'],
  TAKEN_OVER: ['TAKEN_OVER'],
  CLOSED: ['CLOSED'],
  CLOSE_FAILED: ['CLOSE_FAILED'],
};
export const DOC_STATES_FILTER_IS_DTM: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  INPROGRESS: ['INPROGRESS'],
  SUBMITTED: ['SUBMITTED'],
  CANCELED: ['CANCELED'],
  REJECTED: ['REJECTED'],
  WAITING_FOR_IMPORT: ['WAITING_FOR_IMPORT'],
  IMPORT_INTERRUPTED: ['IMPORT_INTERRUPTED'],
  CLOSE_INTERRUPTED: ['CLOSE_INTERRUPTED'],
  IMPORTING: ['IMPORTING'],
  IMPORT_FAILED: ['IMPORT_FAILED'],
  IMPORTED: ['IMPORTED'],
  IMPORTED_WITH_ERRORS: ['IMPORTED_WITH_ERRORS'],
  WAITING_FOR_CLOSE: ['WAITING_FOR_CLOSE'],
  CLOSING: ['CLOSING'],
  CLOSE_FAILED: ['CLOSE_FAILED'],
  CLOSE_CHECKS_FAILED: ['CLOSE_CHECKS_FAILED'],
  EDITING: ['EDITING'],
  NOTIFYING_CLOSE: ['NOTIFYING_CLOSE'],
  NOTIFYING_CLOSE_FAILED: ['NOTIFYING_CLOSE_FAILED'],
  CLOSING_READY_TO_SEND_TO_DMVS: ['CLOSING_READY_TO_SEND_TO_DMVS'],
  NOTIFYING_CLOSED: ['NOTIFYING_CLOSED'],
  WAITING_FOR_CLOSE_FINAL: ['WAITING_FOR_CLOSE_FINAL'],
  CLOSING_FINAL: ['CLOSING_FINAL'],
  CLOSED_FINAL: ['CLOSED_FINAL'],
  CLOSE_FINAL_FAILED: ['CLOSE_FINAL_FAILED'],
};

export const DOC_STATES_FILTER_DMVS_CROSS: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  IMPORTED: ['IMPORTED'],
  WAITING_FOR_CLOSE: [
    'WAITING_FOR_CLOSE',
    'WAITING_FOR_PROCESS',
    'CLOSING',
    'PROCESSING',
    'NOTIFYING_CLOSE',
  ],
  PROCESSED_SENT_TO_COUNTERPART: ['PROCESSED_SENT_TO_COUNTERPART'],
  READY_TO_PROCESS: ['READY_TO_PROCESS'],
  SEND_TO_COUNTERPART_FAILED: ['SEND_TO_COUNTERPART_FAILED'],
  SENT_TO_COUNTERPART: ['SENT_TO_COUNTERPART'],
  EDITING: ['EDITING'],
  FAILED_TO_GET_SYNCHRONIZE_DATA: ['FAILED_TO_GET_SYNCHRONIZE_DATA'],
  READY_TO_SYNCHRONIZE: ['READY_TO_SYNCHRONIZE'],
  WAITING_FOR_SYNCHRONIZE: ['WAITING_FOR_SYNCHRONIZE'],
  SYNCHRONIZE_FAILED: ['SYNCHRONIZE_FAILED'],
  SYNCHRONIZING: ['SYNCHRONIZING'],
  SYNCHRONIZED: ['SYNCHRONIZED'],
  FAILED_TO_SEND_SYNCHRONIZE_DATA: ['FAILED_TO_SEND_SYNCHRONIZE_DATA'],
  WAITING_FOR_SYNCHRONIZE_DATA: ['WAITING_FOR_SYNCHRONIZE_DATA'],
  IMPORTED_WITH_ERRORS: ['IMPORTED_WITH_ERRORS'],
  SUBMITTED: ['SUBMITTED', 'READY_TO_IMPORT'],
  DELEGATED: ['DELEGATED'],
  DELEGATE_FAILED: ['DELEGATE_FAILED'],
  DELEGATE_REJECTED: ['DELEGATE_REJECTED'],
  CLOSE_FAILED: ['CLOSE_FAILED', 'PROCESS_FAILED', 'NOTIFYING_CLOSE_FAILED'],
  DMVS_COMMUNICATION_FAILED: ['DMVS_COMMUNICATION_FAILED'],
  CLOSED: ['CLOSED'],
  REJECTED: ['REJECTED'],
  REJECTED_BY_COUNTERPART: ['REJECTED_BY_COUNTERPART'],
};

export const DOC_STATES_FILTER_KAD: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  INPROGRESS: ['INPROGRESS'],
  SENDING_TO_DMVS: ['SENDING_TO_DMVS'],
  SEND_TO_DMVS_FAILED: ['SEND_TO_DMVS_FAILED'],
  CLOSED: ['CLOSED'],
  CANCELED: ['CANCELED'],
  REJECTED: ['REJECTED'],
};

export const HISTORY_CLOSED: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  CLOSED: ['CLOSED', 'CLOSED_FINAL'],
};

export const DOC_STATES_MANAGER_EXCLUDED: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  DRAFT: ['DRAFT'],
  DRAFT_CHECKED: ['DRAFT_CHECKED'],
};
export const DOC_STATES_MANAGER_IMPORTS: Partial<Record<DOC_STATE, readonly DOC_STATE[]>> = {
  PREPARING_FOR_EDIT: ['PREPARING_FOR_EDIT'],
};

export const DOCUMENTATION_TYPES = DocumentationTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DOCUMENTATION_TYPES = DocumentationTypeEnum;

export const DATA_ORIGIN_TYPES = DataOriginEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DATA_ORIGIN_TYPES = DataOriginEnum;

export const ATTACHMENT_TYPES = AttachmentTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ATTACHMENT_TYPES = AttachmentTypeEnum;

export const REJECTION_REASON = RejectionReasonEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type REJECTION_REASON = RejectionReasonEnum;

export const REJECTION_REASON_DEFAULT: Partial<Record<RejectionReasonEnum, RejectionReasonEnum>> = {
  [REJECTION_REASON.ATTRIBUTE_ATTACHMENT_MISMATCH]: REJECTION_REASON.ATTRIBUTE_ATTACHMENT_MISMATCH,
  [REJECTION_REASON.INSUFFICIENT_SURVEYING]: REJECTION_REASON.INSUFFICIENT_SURVEYING,
  [REJECTION_REASON.OTHER]: REJECTION_REASON.OTHER,
};

export const REJECTION_REASON_DTM_GAD: Partial<Record<RejectionReasonEnum, RejectionReasonEnum>> = {
  [REJECTION_REASON.INCOMPLETE_DOCUMENTATION]: REJECTION_REASON.INCOMPLETE_DOCUMENTATION,
  [REJECTION_REASON.AZI_CHECK_FAILED]: REJECTION_REASON.AZI_CHECK_FAILED,
  [REJECTION_REASON.BAD_ATTACHMENT]: REJECTION_REASON.BAD_ATTACHMENT,
  [REJECTION_REASON.OTHER]: REJECTION_REASON.OTHER,
};

export type UsableItems = (
  | 'name'
  | 'description'
  | 'documentation_type'
  | 'geometry_plan_number'
  | 'buildingCategory'
  | 'utilities'
  | 'data_origin'
  | 'cadasters'
  | 'location'
  | 'geodesist'
  | 'note'
  | 'author'
  | 'owner'
  | 'processor'
  | 'map'
  | 'attachments'
  | 'attachments_isdmvs'
  | 'checks'
  | 'editor_manager'
  | 'initial_import_data_type'
  | 'initial_import_id'
  | 'logs'
  | 'data_type'
  | 'dmvs_id_podani'
  | 'dmvs_identifikace_zmeny'
  | 'dmvs_source'
  | 'created'
  | 'closed'
  | 'subjekt'
  | 'editor_subjekt'
  | 'azi_cislo_opravneni'
  | 'building_id'
  | 'owner_name'
  | 'processor_name'
  | 'processor_organization'
  | 'geodetically_surveyed'
  | 'processed'
  | 'verified'
  | 'verification_number'
  | 'dmvs_rozsahy'
  | 'prejimka_type'
  | 'geodesist_official_number'
)[];

export const usableItemsForFormType: Partial<Record<DocFormTypes, Partial<UsableItems>>> = {
  check: [
    'name',
    'geodesist_official_number',
    'attachments',
    'utilities',
    'checks',
    'prejimka_type',
    'dmvs_id_podani',
    'dmvs_source',
  ],
  doc: [
    'name',
    'dmvs_id_podani',
    'created',
    'closed',
    'description',
    'documentation_type',
    'geometry_plan_number',
    'utilities',
    'buildingCategory',
    'data_origin',
    'cadasters',
    'location',
    'geodesist',
    'note',
    'author',
    'owner',
    'processor',
    'map',
    'attachments',
    'checks',
    'editor_manager',
    'logs',
  ],
  podaniDTI: [
    'name',
    'description',
    'geodesist',
    'data_type',
    'editor_manager',
    'attachments',
    'attachments_isdmvs',
    'checks',
    'logs',
    'subjekt',
    'dmvs_rozsahy',
    'dmvs_source',
  ],
  dmvsDti: [
    'name',
    'description',
    'attachments',
    'attachments_isdmvs',
    'dmvs_identifikace_zmeny',
    'dmvs_id_podani',
    'dmvs_source',
    'subjekt',
    'editor_subjekt',
  ],
  dmvsGad: [
    'name',
    'description',
    'attachments',
    'dmvs_identifikace_zmeny',
    'dmvs_id_podani',
    'dmvs_source',
    'azi_cislo_opravneni',
    'subjekt',
    'editor_manager',
    'checks',
  ],
};

export type UsableFilterItems = (
  | 'name'
  | 'description'
  | 'state' // state__in
  | 'id'
  | 'documentation_type'
  | 'prejimka_type'
  | 'geometry_plan_number'
  | 'buildingCategory'
  | 'utilities_type'
  | 'cadasters'
  | 'data_origin'
  | 'owner' // owner_name, owner_ico, owner_birth_number
  | 'processor' // processor_name, processor_ico, processor_birth_number
  | 'created' // createdGte, createdLt
  | 'finished' // finishedGte, finishedLte
  | 'closed' // closedGte, closedLt
  | 'creatorFullName'
  | 'receiverFullName'
  | 'geodesistFullName'
  | 'editorManagerFullName'
  | 'dmvs_id_podani'
  | 'dmvs_source'
  | 'history'
)[];
export const usableFilterItemsForAppType: Record<
  DmxConfig['customerType'],
  Partial<UsableFilterItems>
> = {
  gp: [
    'name',
    'description',
    'state',
    'id',
    'documentation_type',
    'prejimka_type',
    'geometry_plan_number',
    'buildingCategory',
    'utilities_type',
    'cadasters',
    'data_origin',
    'owner',
    'processor',
    'created',
    'finished',
    'closed',
    'creatorFullName',
    'receiverFullName',
    'geodesistFullName',
    'dmvs_id_podani',
    'history',
  ],
  ipr: [
    'name',
    'description',
    'state',
    'id',
    'prejimka_type',
    'created',
    'finished',
    'dmvs_id_podani',
    'dmvs_source',
    'history',
  ],
  dtm: [
    'name',
    'description',
    'state',
    'id',
    'prejimka_type',
    'created',
    'finished',
    'dmvs_id_podani',
    'dmvs_source',
    'history',
  ],
  cepro: ['name', 'description', 'state', 'id', 'created'],
  bb: ['name', 'description'],
};

export const KRAJ_STAFF_ROLES: Roles[] = [
  Roles.ADMIN,
  Roles.MANAGER_MANAGER,
  Roles.MANAGER_SUPERVISOR,
  Roles.MANAGER_EDITOR,
];

export const REJECTION_REASON_STATES: DOC_STATE[] = [DOC_STATE.REJECTED, DOC_STATE.SUBMITTED];
export const EDITOR_VISIBLE_STATE: DOC_STATE[] = [
  DOC_STATE.EDITING,
  DOC_STATE.EDIT_SUPERVISING,
  DOC_STATE.EDIT_REJECTED,
];
export const MAP_VISIBLE_STATE: DOC_STATE[] = [
  DOC_STATE.PREPARING_FOR_EDIT,
  DOC_STATE.EDITING,
  DOC_STATE.EDIT_SUPERVISING,
  DOC_STATE.EDIT_REJECTED,
];

// DOC LIST FILTER
export const DOC_ROUTER_FILTER_DMVS_DTI = [
  'managerDocListDmvsDti',
  'managerDocListDmvsDtiClosed',
  'managerDocListDmvsDtiRejected',
  'managerDocListDmvsDtiFailed',
  'managerDocListDmvsDtiOngoing',
];

export const DOC_ROUTER_FILTER_DMVS_GAD = [
  'managerDocListDmvsGad',
  'managerDocListDmvsGadSubmitted',
  'managerDocListDmvsGadClosed',
  'managerDocListDmvsGadEditing',
  'managerDocListDmvsGadRejected',
  'managerDocListDmvsGadFailed',
  'managerDocListDmvsGadOngoing',
];

export const DOC_ROUTER_FILTER_IS_DTM = ['managerDocListIsDtm'];

export const DOC_ROUTER_FILTER_DMVS_CROSS = [
  'managerDocListDmvsCross',
  'managerDocListDmvsCrossNew',
  'managerDocListDmvsCrossProcessing',
  'managerDocListDmvsCrossWaiting',
  'managerDocListDmvsCrossClosed',
  'managerDocListDmvsCrossRejected',
  'managerDocListDmvsCrossFailed',
  'managerDocListDmvsCrossSvu',
];

export const DOC_ROUTER_FILTER_PODANI_KAD = ['managerDocListPodaniKad'];

export const checkSourceEnum = {
  ISDMVS: 'ISDMVS',
  ISDTMK: 'ISDTMK',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CheckSourceEnum = ValuesOf<typeof checkSourceEnum>;

export const OWNER_FLOWS: FlowEnum[] = [
  FlowEnum.CROSS_OWNER,
  FlowEnum.SVU_OWNER,
  FlowEnum.SVU_CROSS_OWNER,
];
export const WORKER_FLOWS: FlowEnum[] = [
  FlowEnum.CROSS_WORKER,
  FlowEnum.SVU_WORKER,
  FlowEnum.SVU_CROSS_WORKER,
];
export const FLOW_CROSS: FlowEnum[] = [
  FlowEnum.CROSS_OWNER,
  FlowEnum.CROSS_WORKER,
  FlowEnum.SVU_OWNER,
  FlowEnum.SVU_WORKER,
  FlowEnum.SVU_CROSS_WORKER,
  FlowEnum.SVU_CROSS_OWNER,
];
export const CHECK_FLOWS: FlowEnum[] = Object.values(FlowEnum).filter((flow) => {
  const parts = flow.split('_');
  return parts[0] === 'CHECK' || parts[parts.length - 1] === 'CHECK';
});
